import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { formatDayjsToYmd, parseYmdToDayjs } from '../utils/adminDateUtils';

export const adminDateFieldSx = {
  '& .MuiInputBase-root': {
    height: 40,
    fontSize: '0.9rem'
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.85rem'
  }
};

/**
 * Single date field (MUI calendar — Safari + Chrome). Value is YYYY-MM-DD or ''.
 */
export default function AdminDatePicker({
  label,
  value = '',
  onChange,
  minDate,
  maxDate,
  disabled = false,
  required = false,
  sx = {},
  fullWidth = false
}) {
  const dayjsValue = parseYmdToDayjs(value);
  const min = minDate ? parseYmdToDayjs(minDate) : undefined;
  const max = maxDate ? parseYmdToDayjs(maxDate) : undefined;

  return (
    <DatePicker
      label={label}
      value={dayjsValue}
      minDate={min}
      maxDate={max}
      disabled={disabled}
      onChange={(v) => onChange(formatDayjsToYmd(v) || '')}
      format="DD/MM/YYYY"
      slotProps={{
        textField: {
          size: 'small',
          required,
          fullWidth,
          sx: { ...adminDateFieldSx, ...sx }
        },
        htmlInput: { 'aria-label': label },
        field: { clearable: !required }
      }}
    />
  );
}
